import type { MediaEntry } from "../Gallery/GalleryUIFunctions";

const IMAGE_BASE = process.env.REACT_APP_PUBLIC_IMAGE_BASE_URL!;
const API_ORIGIN = process.env.REACT_APP_API_BASE_URL!.replace(/\/api\/?$/, "");

const toImageUrl = (p?: unknown): string => {
  if (typeof p !== "string") return "";
  if (/^(https?:|data:)/i.test(p)) return p;

  const base = process.env.REACT_APP_PUBLIC_IMAGE_BASE_URL || "";
  const normalized = `${base.replace(/\/$/, "")}/${p.replace(/^\//, "")}`;

  if (normalized.includes("cloudflareaccess")) {
    console.warn("🚨 BAD IMAGE URL:", normalized);
  }

  return normalized;
};

export const asMediaEntry = (m: any): MediaEntry | null => {
  if (!m) return null;

  if (m?.isHls && m?.videoId) {
    return {
      isHls: true,
      videoId: m.videoId,
      url: m.url ?? m.hlsUrl ?? `${API_ORIGIN}/hls/playlist/${m.videoId}`,
      hlsUrl: m.hlsUrl ?? m.url ?? `${API_ORIGIN}/hls/playlist/${m.videoId}`,
      dashUrl: m.dashUrl ?? null,
      posterUrl: m.posterUrl ?? null,
      musicId: m.musicId ?? m.music?._id ?? null,
      musicTitle: m.musicTitle ?? m.music?.title ?? null,
      musicArtist: m.musicArtist ?? m.music?.artist ?? null,
    };
  }

  const raw = m.url ?? m.path ?? null;
  if (!raw) return null;

  return {
    url: toImageUrl(raw),
    musicId: m.musicId ?? m.music?._id ?? null,
    musicTitle: m.musicTitle ?? m.music?.title ?? null,
    musicArtist: m.musicArtist ?? m.music?.artist ?? null,
  };
};

export function formatMediaArray(media: unknown): MediaEntry[] {
  if (!Array.isArray(media)) {
    console.warn("⚠️ formatMediaArray: media is not an array", media);
    return [];
  }

  console.groupCollapsed('%c🧩 formatMediaArray() input', 'color:#64dd17');
  media.forEach((m, i) => {
    console.log(`Media[${i}]`, m);
  });
  console.groupEnd();

  return media
    .map((m): MediaEntry | null => {
      if (m?.isHls === true && m.videoId) {
        return {
          isHls: true,
          videoId: m.videoId,
          url: m.url ?? m.hlsUrl ?? `${API_ORIGIN}/hls/playlist/${m.videoId}`,
          hlsUrl: m.hlsUrl ?? m.url ?? `${API_ORIGIN}/hls/playlist/${m.videoId}`,
          dashUrl: m.dashUrl ?? null,
          posterUrl: m.posterUrl ?? null,
          musicId: m.musicId ?? m.music?._id ?? null,
          musicTitle: m.musicTitle ?? m.music?.title ?? null,
          musicArtist: m.musicArtist ?? m.music?.artist ?? null,
        };
      }

      const raw =
        typeof m === "string"
          ? m
          : typeof m?.url === "string"
          ? m.url
          : typeof m?.path === "string"
          ? m.path
          : null;

      if (!raw) {
        console.warn("⛔ Invalid image media:", m);
        return null;
      }

      return {
        url: toImageUrl(raw),
        musicId: m.musicId ?? m.music?._id ?? null,
        musicTitle: m.musicTitle ?? m.music?.title ?? null,
        musicArtist: m.musicArtist ?? m.music?.artist ?? null,
      };
    })
    .filter((m): m is MediaEntry => Boolean(m));
}